import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import React, { useContext, useState } from 'react';
import Grid from '@mui/material/Grid/Grid';
import { t } from '../../../../../../types/translation/Translator';
import { ProductMasterDataContext } from '../../../../../../context/ProductMasterDataContext';
import { ReorderRuleProduct } from '../../ReorderRuleScreen';
import DropdownSelect from '../../../DropdownSelect';
import { ProductMasterData } from '../../../../../../types/product_master_data/productMasterData';
import Modal from '../../../../../../VentoryUI/components/common/Modal/Modal';
import { AddButton } from '../../../../../../VentoryUI/components/common/Button/Templates';
import ModalPane from '../../../../../../VentoryUI/components/common/Modal/components/ModalPane';
import { CompanyContext } from '../../../../../../context/CompanyContext';

interface AddReorderRuleProductModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  reorderRuleProducts: Map<string, ReorderRuleProduct>;
  setReorderRuleProducts: (reorderRuleProducts: Map<string, ReorderRuleProduct>) => void;
}

export default function AddReorderRuleProductModal({
  open,
  setOpen,
  reorderRuleProducts,
  setReorderRuleProducts,
}: AddReorderRuleProductModalProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { productMasterData, productMasterDataLoading } = useContext(ProductMasterDataContext);

  const [selectedProduct, setSelectedProduct] = useState<ProductMasterData | null>(null);

  return (
    <Modal
      open={open}
      onClose={() => {
        setSelectedProduct(null);
        setOpen(false);
      }}
      title={t(TranslationKey.addProduct).singular.label}
    >
      <ModalPane>
        <Grid container className='h-[250px]' alignContent={'space-between'}>
          <Grid item xs={12}>
            <DropdownSelect
              placeholder={t(TranslationKey.selectAProduct).singular.label}
              disabled={productMasterDataLoading}
              values={[...productMasterData.values()].filter(
                pmd => pmd.companyId === currentCompany.id && !reorderRuleProducts.has(pmd.id),
              )}
              selectedValue={selectedProduct}
              toText={item => `${item.productName} (${item.productNumber})`}
              toElement={item => {
                return (
                  <Grid container>
                    <Grid item xs={12}>
                      <p className='text-sm font-bold'>{item.productName}</p>
                    </Grid>
                    <Grid item my={'auto'} xs={12}>
                      <p className='text-sm text-gray-500'>{`${item.productNumber}`}</p>
                    </Grid>
                  </Grid>
                );
              }}
              onChange={item => {
                setSelectedProduct(item);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Grid container justifyContent={'flex-end'}>
              <Grid item>
                <AddButton
                  disabled={!selectedProduct}
                  onClick={() => {
                    if (!selectedProduct) return;
                    const map = new Map<string, ReorderRuleProduct>();
                    map.set(selectedProduct.id, {
                      productMasterDataId: selectedProduct.id,
                      reorderQuantity: '1',
                      replenishQuantity: '0',
                    });
                    [...reorderRuleProducts.values()].forEach(item => map.set(item.productMasterDataId, item));

                    setReorderRuleProducts(map);
                    setSelectedProduct(null);
                    setOpen(false);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ModalPane>
    </Modal>
  );
}
